import { cn } from '@ctct/summit-core';
import { SearchIcon as DefaultIcon } from '@ctct/summit-icons';
import { Command as CommandPrimitive } from 'cmdk';
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  type ElementType,
  forwardRef,
} from 'react';

interface CommandInputProps extends ComponentPropsWithoutRef<typeof CommandPrimitive.Input> {
  SearchIcon?: ElementType | null;
  inputWrapperClasses?: string;
}

/**
 * The input bar to filter from list
 */
const CommandInput = forwardRef<ElementRef<typeof CommandPrimitive.Input>, CommandInputProps>(
  ({ className, SearchIcon = DefaultIcon, inputWrapperClasses, ...props }, ref) => (
    <div className={cn('r:flex r:items-center r:border-b r:px-3 r:w-full', inputWrapperClasses)}>
      {SearchIcon && <SearchIcon className="r:mr-2 r:h-5 r:w-5 r:shrink-0 r:opacity-50" />}
      <CommandPrimitive.Input
        ref={ref}
        className={cn(
          'rds-command-input',
          `
          r:h-(--height)
          r:flex r:w-full r:rounded-md r:py-3 r:outline-hidden
          r:bg-transparent r:text-base
          r:placeholder:text-(--text-placeholder)
          r:disabled:cursor-not-allowed
          r:disabled:opacity-50
        `,
          className
        )}
        data-sds-id="command-input"
        {...props}
      />
    </div>
  )
);

CommandInput.displayName = 'CommandInput';

export { CommandInput, type CommandInputProps };
